/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * Ошибка на стороне сервиса
 */
export interface GenericError {
  /** Название ошибки */
  name?: string;

  /** Описание ошибки */
  description?: string;

  /** Дата и время возникновения ошибки */
  timestamp?: string;
}

/**
 * Пусто ok-ответ
 */
export type EmptyResponse = object;

/**
 * Тип остатка по счету
 */
export enum AccountBalanceTypeEnum {
  CURRENT = "CURRENT",
  AVAILABLE = "AVAILABLE",
}

/**
 * Тело ответа на запрос получение пользовательских настроек
 */
export interface UserSettingsResp {
  /** Тип остатка по счету */
  accountBalanceType?: AccountBalanceTypeEnum;

  /**
   * Туториал по счетам
   * @example false
   */
  showAccountTutorial?: boolean;

  /**
   * Туториал по главному меню
   * @example false
   */
  showMainTutorial?: boolean;
}

import { HttpClient } from "../../client";
import { ContentType, RequestParams } from "../../client/types";

/**
 * @title Микросервис пользовательские настройки
 * @version 1.0
 * @license Все права защищены ООО РСХБ-ИНТЕХ
 * @baseUrl https://owb-ms-prd-user-settings.ndbo.dev.rshbdev.ru
 * @contact ООО РСХБ-ИНТЕХ <info@rshbintech.ru> (https://rshbintech.ru/)
 */
export class Api<
  SecurityDataType extends unknown
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags Настройки пользователя
     * @name GetShowTutorial
     * @summary Получение актуальности просмотренных туториалов
     * @request GET:/api/user-settings/v1/external/user-settings/show-tutorial/{showTutorialName}
     */
    getShowTutorial: (showTutorialName: string, params: RequestParams = {}) =>
      this.request<boolean, GenericError>({
        path: `/api/user-settings/v1/external/user-settings/show-tutorial/${showTutorialName}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Настройки пользователя
     * @name SetShowTutorial
     * @summary Установка показа туториалов
     * @request POST:/api/user-settings/v1/external/user-settings/show-tutorial/{showTutorialName}
     */
    setShowTutorial: (
      showTutorialName: string,
      data: boolean,
      params: RequestParams = {}
    ) =>
      this.request<EmptyResponse, GenericError>({
        path: `/api/user-settings/v1/external/user-settings/show-tutorial/${showTutorialName}`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Настройки пользователя
     * @name GetAccountBalanceType
     * @summary Получение актуальности типа остатка по счету
     * @request GET:/api/user-settings/v1/external/user-settings/account-balance-type
     */
    getAccountBalanceType: (params: RequestParams = {}) =>
      this.request<AccountBalanceTypeEnum, GenericError>({
        path: `/api/user-settings/v1/external/user-settings/account-balance-type`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Настройки пользователя
     * @name SetAccountBalanceType
     * @summary Установка актуальности типа остатка по счету
     * @request POST:/api/user-settings/v1/external/user-settings/account-balance-type
     */
    setAccountBalanceType: (
      data: AccountBalanceTypeEnum,
      params: RequestParams = {}
    ) =>
      this.request<EmptyResponse, GenericError>({
        path: `/api/user-settings/v1/external/user-settings/account-balance-type`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Настройки пользователя
     * @name GetUserSettings
     * @summary Получение всех настроек пользователя
     * @request GET:/api/user-settings/v1/external/user-settings
     */
    getUserSettings: (params: RequestParams = {}) =>
      this.request<UserSettingsResp, GenericError>({
        path: `/api/user-settings/v1/external/user-settings`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
}

export const api = new Api();
